import React from "react";
import { FilterMode } from "./Filtermode";
import BasicGrid from "./Grid";

const LiquidationBarcodeFinalReport = () => {
  return (
    <>
      <FilterMode />
      <BasicGrid />
    </>
  );
};

export default LiquidationBarcodeFinalReport;
